import { useTranslation } from "react-i18next";

export const useToolsData = () => {
  const { t } = useTranslation("tools");

  const toolsData = [
    {
      id: 1,
      name: "FinderSite",
      description: t("finderSite.description"),
      recommendedText: t("finderSite.recommendedText"),
      image: {
        src: "/images/tools/tools-finder-site.png",
        alt: t("finderSite.imgAltText")
      }
    },
    {
      id: 2,
      name: "FinderX",
      description: t("finderX.description"),
      recommendedText: t("finderX.recommendedText"),
      image: {
        src: "/images/tools/tools-finder-x.png",
        alt: t("finderX.imgAltText")
      }
    },
    {
      id: 3,
      name: "FinderAI Chat Recap",
      description: t("finderGram.description"),
      recommendedText: t("finderGram.recommendedText"),
      image: {
        src: "/images/tools/tools-finder-chat-recap.png",
        alt: t("finderGram.imgAltText")
      }
    }
  ];

  return toolsData;
};
